<template>
     <div id="Tariff" style="float: right;width:100%;height: 100%;direction:rtl">
        <div class="card" style="float: right;width:100%;height: 100%">
            <div class="card-header">
                <CRow>
                     <h3 class="card-title"  > <CIcon name="cil-map" style="width: 20px;height: 20px"/>&nbsp;&nbsp;
                        جدول تعرفه
                    </h3>
                </CRow>
               
                <CRow>
                    <CCol>                    
                        <CSelect label="انتخاب خط"    :options="GetOtions($store.state.Fleets.RequestResponse)" :value.sync="FleetID"   @change="changeValue"    style="color: white" > </CSelect>
                    </CCol>
                    <CCol>
                        <CSelect label="انتخاب روز"    :options="GetOtionsDay($store.state.DayDefine_GetAll.RequestResponse)" :value.sync="DayDefineID" @change="changeValue"  style="color: white" > </CSelect>
                    </CCol>
                    <CCol>
                        
                    </CCol>
                    <CCol>
                        
                    </CCol>
                </CRow>
            </div>
            <div class="card-body" style="float: right;width:100%;height: 100%;min-height: 450px">
                <CDataTable
                    :hover="true"
                    :border="true"
                    
                    :striped="true"
                    :small="true"
                    :items="$store.state.SmartTariff_GetToDay.RequestResponse"
                    :fields="fields"
                    :fixed="true"
                    :clickableRows="true"
                    :items-per-page="40"
                    pagination
                    style="float: right;width: 100%;overflow: hidden"
                    :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"

                >
                    <template #Rows="{index}">
                        <td >
                            {{index+1}}
                        </td>
                    </template>
                    <template #STime="{item}">
                        <td style="direction:ltr">
                            {{GetDateTime(item.STime)}}
                        </td>
                    </template>
                </CDataTable>
            </div>
            <div class="card-footer" style="direction:ltr;display: flex;gap:10px" v-if="$store.state.SmartTariff_GetToDay.RequestResponse.length>0">
                
                <MPrint 
                    v-if="$store.state.SmartTariff_GetToDay.RequestResponse.length>0"
                    :data="$store.state.SmartTariff_GetToDay.RequestResponse"
                    :fields="fields"
                    label="PDF" title="جدول تعرفه">
                </MPrint>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
export default {
    data(){
        return {
            FleetID:0,
            DayDefineID:0,
            fields:[{"key":"Rows","label":"ردیف"},{"key":"DeviceID","label":"شماره شناسایی"},{"key":"STime","label":"تایم حرکت"},{"key":"VehicleName","label":"نام خودرو"}],
        }
    },
    computed:{

    },
    watch:{

    },
    mounted(){
        this.GetFleets();
        this.DayDefine_GetAll();
    },
    methods:{
        GetFleets(){
            this.$store.commit('FleetByUser');
        },
        DayDefine_GetAll(){
            this.$store.commit('DayDefine_GetAll');
            
        },
        changeValue(){
            if(this.FleetID!==0 && this.DayDefineID!==0){
                this.SmartTariff_GetToDay();
            }
        },
        SmartTariff_GetToDay(){
            this.$store.commit('SmartTariff_GetToDay',{
                FleetID:this.FleetID,
                DayDefineID:this.DayDefineID,
            });
        },
        GetOtions(fleets){
            var options=[];
            var all={value:-1,label:'-- انتخاب کنید --',disabled:true};
            options.push(all);
            for(var i=0;i<fleets.length;i++){
                var fleet=fleets[i];
                var option={value:fleet.FleetID,label:fleet.FleetName};
                options.push(option);
            }
            return options;
        },
        GetOtionsDay(items){
                var options=[];
                 var all={value:0,label:'-- انتخاب کنید --',disabled:true};
                 options.push(all);
                for(var i=0;i<items.length;i++){
                    var item=items[i];
                    var option={value:item.DayDefineID,label:item.Name};
                    options.push(option);
                }
                return options;
        },
        changeFleet(){
            this.GetDeviceByFleet(this.FleetID);
        },
        GetDeviceByFleet(fleetID){
            this.$store.commit('Device_GetByFleetID_SortMaxEN',{
                FleetID:fleetID
            });
        },
        UpdateSort(){
            for(var i=0;i<this.$store.state.Devices.RequestResponse.length;i++){
                this.$store.commit('Device_UpdateMaxEN',{
                    DeviceID:this.$store.state.Devices.RequestResponse[i].DeviceID,
                    MaxEN:i
                });
            }
        },
        GetDateTime(time){
            if(time!=null)
                return Vue.moment(time, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
            else "نامشخص";
        },
        
    }
}
</script>